// extracted by mini-css-extract-plugin
export var detailNavigation = "styles-module--detailNavigation--360d6";
export var hidden = "styles-module--hidden--72035";
export var navigationLink = "styles-module--navigationLink--8a71e";
export var navigationText = "styles-module--navigationText--98375";
export var next = "styles-module--next--b745c";
export var previous = "styles-module--previous--859d1";
export var spaced = "styles-module--spaced--f7941";
export var styled = "styles-module--styled--02628";